import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";
import { MonitorEventListFilters } from "../../../service/ApiMonitorEvent";

export const GET_USER_MONITOR_EVENT_LIST_FAIL =
  "USER-MONITOR-EVENT:GET_USER_MONITOR_EVENT_LIST_FAIL";

export interface GetUserMonitorEventListFailAction extends Action {
  type: typeof GET_USER_MONITOR_EVENT_LIST_FAIL;
  organization: OrganizationKeyName;
  filters: MonitorEventListFilters;
}

export const getUserMonitorEventListFailAction = (
  organization: OrganizationKeyName,
  filters: MonitorEventListFilters
): GetUserMonitorEventListFailAction => ({
  type: GET_USER_MONITOR_EVENT_LIST_FAIL,
  organization,
  filters,
});
